import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  Clock, 
  Trophy, 
  Settings, 
  Target,
  Sparkles
} from 'lucide-react';
import { useGameStore } from '../store/gameStore';

const Header: React.FC = () => {
  const location = useLocation();
  const { currentAge, gamePhase } = useGameStore();

  const navigation = [
    { name: 'Dashboard', href: '/', icon: Home },
    { name: 'Timeline', href: '/timeline', icon: Clock },
    { name: 'Achievements', href: '/achievements', icon: Trophy },
    { name: 'Settings', href: '/settings', icon: Settings },
  ];


  if (gamePhase === 'intro' || gamePhase === 'completed' || gamePhase === 'dead') {
    return null;
  }

  return (
    <div className="bg-slate-800/50 backdrop-blur-xl border-b border-slate-700/50 sticky top-0 z-30">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo & Game Info */}
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                <Sparkles className="text-white text-lg" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">SppefRun Life</h1>
                <div className="flex items-center space-x-2 text-slate-300">
                  <Clock size={14} />
                  <span className="text-sm">Age {currentAge}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex items-center space-x-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              const Icon = item.icon;
              
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-xl font-medium transition-all duration-300 ${
                    isActive
                      ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg'
                      : 'text-slate-300 hover:text-white hover:bg-slate-700/50'
                  }`}
                >
                  <Icon size={18} />
                  <span>{item.name}</span>
                </Link>
              );
            })}
          </nav>

        </div>
      </div>
    </div>
  );
};

export default Header;